import { useState } from 'react'

import { Button, Dialog, DialogContent, DialogTrigger } from '@/_components/ui'

import { SendRecoveryPasswordEmailDialog } from './send-recovery-password-email-dialog'

type SendRecoveryPasswordEmailButtonProps = {
  name: string
  email: string
}

export const SendRecoveryPasswordEmailButton = ({
  name,
  email,
}: SendRecoveryPasswordEmailButtonProps) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false)
  return (
    <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
      <DialogTrigger asChild>
        <Button variant="gray" size="brand" className="rounded-[4px] text-xs font-bold">
          Enviar e-mail de recuperação
        </Button>
      </DialogTrigger>

      <DialogContent className="min-w-[336px] max-w-[389px] p-5">
        <SendRecoveryPasswordEmailDialog
          name={name}
          email={email}
          setIsDialogOpen={setIsDialogOpen}
        />
      </DialogContent>
    </Dialog>
  )
}
